import { AlkLogger } from '@alk/core';
import { filter } from 'rxjs/operators';
import { IStreamData } from '../interfaces';
import { MonoTypeOperatorFunction } from 'rxjs';

export type Nullable<T> = T | null;

export type NullableNumber = Nullable<number>;

/**
 * Function sanitize incomming feed
 * And filtering if communication token not the same
 * @param token communication token
 */
export const checkFeed = (token: NullableNumber, caller: string): MonoTypeOperatorFunction<IStreamData<Uint8Array>> => {
    return filter(data => {
        if (data.communicationToken !== token){
            AlkLogger.debug([
                `${ caller } received unexpected feed with token`,
                `${ data.communicationToken }, expected ${ token }`,
            ].join(' '));
            return false;
        }

        return true;
    });
};
